/** Snow step (fx 'snowstep'): a burst of snow and streaks rising off the caster. */
import { registerFx } from './registry';

const R = Math.random;

registerFx('snowstep', (host) => ({
  skill: ({ sx, sy }) => {
    host.fx.push({ type: 'ring', x: sx, y: sy, t: 0, life: 0.5, r: 24, col: '235,245,255' });
    host.snowBurst(sx, sy - 6, 16, false);
    for (let k = 0; k < 8; k++)
      host.parts.push({
        x: sx + (R() - 0.5) * 16,
        y: sy - R() * 30,
        vx: 0,
        vy: -90 - R() * 40,
        g: 0,
        t: 0,
        life: 0.35,
        c: '#e8f6ff',
        streak: true,
      });
    host.sfx.dash();
  },
}));
